// extracted by mini-css-extract-plugin
module.exports = {"main":"CounterboreHoles_main__1phtf","Type":"CounterboreHoles_Type__1Olsk","imgContainer":"CounterboreHoles_imgContainer__QHRuP"};